<div class="vox-dropdown-input dropdown" dropdown>
  <div ngbDropdown class="vox-dropdown-input dropdown equipment-type">
    <button class="dropdown__btn" id="type" ngbDropdownToggle type="button">
      {{selected}}
      <span class="caret"></span>
    </button>
    <div ngbDropdownMenu aria-labelledby="type">
      <button *ngFor="let u of users" ngbDropdownItem class="dropdown__item" type="button"
        (click)="selectUser(u)"><span>{{ u.full_name || 'no users' }}</span></button>
    </div>
  </div>
</div>
